import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import Meta from "../../components/Meta";
import { listPortfolio } from "../../actions/portfolioActions";
import PortfolioMagazine from "../../components/portfolio/PortfolioMagazine";

export default function ProductionScreen() {
  const dispatch = useDispatch();

  const {
    loading,
    error,
    items = [],
  } = useSelector((state) => state.portfolioList);

  useEffect(() => {
    dispatch(listPortfolio("production"));
  }, [dispatch]);

  const hasItems = items.length > 0;

  return (
    <>
      <Meta
        title="Costume Production London | Academy Costumes London"
        description="Academy Costumes London provides costume production services in London for film, television, theatre, fashion, music, commercials and private commissions."
        image="/images/home/production.jpg"
        url="/production"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Costume Production", url: "/production" },
        ]}
      />

      <Container as="main" fluid className="p-0">
        {loading ? (
          <div className="p-4">
            <Loader />
          </div>
        ) : error ? (
          <div className="p-4">
            <Message variant="danger">{error}</Message>
          </div>
        ) : hasItems ? (
          <PortfolioMagazine items={items} />
        ) : (
          <div className="p-4">
            <Message>No production slides yet.</Message>
          </div>
        )}
      </Container>
    </>
  );
}
